/**
 * Pads a number with leading zeros to reach the specified length.
 *
 * @param value - The number to pad
 * @param length - The desired length of the padded string (default: 2)
 * @returns The padded number as a string
 *
 * @example
 * padNumber(5) // "05"
 * padNumber(5, 3) // "005"
 * padNumber(42) // "42"
 * padNumber(123, 2) // "123"
 */
export function padNumber(value: number, length: number = 2): string {
  return value.toString().padStart(length, "0");
}
